// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"41d2437c","732":"054a0f44","977":"b91e2570"}[chunkId] + ".chunk.js";
};